import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, nextToPromise, toObservable } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource, invalidateResource } from "kea-resource";
import * as rx from "rxjs";
import { EntregaZERealizadaForm } from "./formn";

type Entity = models.EntregaZERealizadaDTO;

interface Props2 {
    match: match<{ id: string }>
}

interface Props {
    idEntrega: string;
    idDestino: string
}

interface State {
    value?: Entity;
}

class EntregaZERealizadaEditNoRX extends React.PureComponent<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {};
    }
    idEntregaStr = (props: Props, state: State) => this.props.idEntrega;
    idDestinoStr = (props: Props, state: State) => this.props.idDestino;
    idViajeZENul = (props: Props, state: State) => observeResource(resources.ViajeZEApp.ObtenerIdViajeZEUsuario);

    idEntrega = createSelectorRx(this.idEntregaStr, id => id == "new" ? "new" : Number.parseInt(id));
    idDestino = createSelectorRx(this.idDestinoStr, id => Number.parseInt(id));
    idViajeZE = createSelectorRx(this.idViajeZENul, id => id!);
    esNuevo = createSelectorRx(this.idEntrega, id => id == "new");

    nuevoValue = (props: Props, state: State) => ({
        TipoPago: models.TipoPagoEntregaZE.Efectivo
    } as Entity)

    guias = createSelectorRx(this.idViajeZE, this.idDestino, this.idEntrega, (idViajeZE, idDestino, idEntrega) =>
        observeResource(resources.ViajeZEApp.ObtenerGuiasDeEntrega, idViajeZE!, idDestino, idEntrega == "new" ? null : idEntrega));

    informacionEntrega = createSelectorRx(this.idViajeZE, this.idDestino, this.idEntrega, (idViajeZE, idDestino, idEntrega) =>
        observeResource(resources.ViajeZEApp.ObtenerInformacionEntrega, idViajeZE!, idDestino, idEntrega == "new" ? null : idEntrega));

    newValue = createSelectorRx(this.nuevoValue, this.idViajeZE, this.idDestino, this.guias, (nuevoValue, idViajeZE, idDestino, guias) => ({ ...nuevoValue, IdViajeZE: idViajeZE, IdDireccionDestino: idDestino, Guias: guias, GuiasEntregadas: [], GuiasNoEntregadas: [] }));

    valueFromResource = createSelectorRx(this.idEntrega, this.esNuevo, (id, esNuevo) => !esNuevo ?
        observeResource(resources.ViajeZEApp.ObtenerEntrega, id)
        : rx.Observable.from([null]));

    valueFromState = (props: Props, state: State) => state.value;

    value = createSelectorRx(this.valueFromState, this.valueFromResource, this.newValue, (state, resource: (Entity | undefined), nuevo) => (state || resource || nuevo) as Entity);

    onChange = (value: Entity) => new Promise<void>(resolve => this.setState({ value: value }, resolve));


    onGuardar = async () => {
        const valueObs = this.value(this.props, this.state);
        const value = await nextToPromise(valueObs);
        value.Fecha = new Date();
        await resources.ViajeZEApp.RealizarEntrega(value);
    }

    render() {
        const informacionEntrega = this.informacionEntrega(this.props, this.state);
        const value = this.value(this.props, this.state);
        const esNuevo = this.esNuevo(this.props, this.state);

        return <EntregaZERealizadaForm
            value={value}
            nuevo={esNuevo}
            informacion={informacionEntrega}
            onChange={this.onChange}
            onGuardar={this.onGuardar} />;
    }

}

export const EntregaZERealizadaEdit = withRouter(EntregaZERealizadaEditNoRX);


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/viajeappZE/entrega/edit.tsx